const colors = {
    appBarBackground: '#F8F8F8',
    lightShadow: '#F0F0F0',
    black: '#000000',
    button: '#00b1b2',
    darkGray: '#222222',
    focusedField: '#21a7b0',
    main: '#00b1b2',
    lightMain: '#21a7b0',
    lighterMain: 'rgba(21,43,78,0.5)',
    lightBorderGray: '#E1E1E1',
    lightGray: '#F3F0F0',
    lightDarkerGray: '#BFBFBF',
    darkIcon: '#263238',
    labelColor: '#929292',
    lightWarning: 'rgba(255, 0, 0, 0.20)',
    midGray: '#C4C4C4',
    midDarkerGray: '#737373',
    warning: '#FF0000',
    white: '#FFFFFF',
}

export default colors
